export default __webpack_public_path__ + "static/media/heart_pink.1b1fbcc3.svg";